import {
  ArrowForward as ArrowForwardMui,
  Assignment as AssignmentMui,
  Book as BookMui,
  CalendarMonth as CalendarMonthIconMui,
  Check as CheckMui,
  Close as CloseMui,
  Code as CodeMui,
  Diversity3 as Diversity3Mui,
  Email as EmailMui,
  Error as ErrorMui,
  ExpandMore as ExpandMoreMui,
  FactCheck,
  Groups as GroupsMui,
  Highlight as HighlightMui,
  Info as InfoMui,
  InfoOutlined,
  Key as KeyMui,
  Link as LinkMui,
  LocationCity as LocationCityMui,
  Lock as LockIconMui,
  Pending as PendingMui,
  Print as PrintMui,
  Quiz as QuizMui,
  Redo as RedoMui,
  Refresh as RefreshMui,
  School as SchoolIconMui,
  Search as SearchMui,
  Shuffle as ShuffleMui,
  Start as StartMui,
  Subscript as SubscriptMui,
  Superscript as SuperscriptMui,
  Sync as SyncMui,
  Tv,
  Undo as UndoMui,
  VolumeOff as VolumeOffMui,
  ZoomIn as ZoomInMui,
  ZoomOut as ZoomOutMui,
} from '@mui/icons-material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import AddCommentIcon from '@mui/icons-material/AddComment';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import ApprovalIcon from '@mui/icons-material/Approval';
import ArticleIcon from '@mui/icons-material/Article';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssistantIcon from '@mui/icons-material/Assistant';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AttributionIcon from '@mui/icons-material/Attribution';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import BackpackIcon from '@mui/icons-material/Backpack';
import BadgeIcon from '@mui/icons-material/Badge';
import BarChartIcon from '@mui/icons-material/BarChart';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';
import BrightnessLowIcon from '@mui/icons-material/BrightnessLow';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import BusinessIcon from '@mui/icons-material/Business';
import CableIcon from '@mui/icons-material/Cable';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ConstructionIcon from '@mui/icons-material/Construction';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import DangerousIcon from '@mui/icons-material/Dangerous';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import DnsIcon from '@mui/icons-material/Dns';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import EditIcon from '@mui/icons-material/Edit';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import FlagIcon from '@mui/icons-material/Flag';
import FlipIcon from '@mui/icons-material/Flip';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import FormatColorTextIcon from '@mui/icons-material/FormatColorText';
import FormatIndentIncreaseIcon from '@mui/icons-material/FormatIndentIncrease';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import ForumIcon from '@mui/icons-material/Forum';
import Forward10Icon from '@mui/icons-material/Forward10';
import GradeOutlinedIcon from '@mui/icons-material/GradeOutlined';
import GradingIcon from '@mui/icons-material/Grading';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import HailIcon from '@mui/icons-material/Hail';
import HelpIcon from '@mui/icons-material/Help';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InventoryIcon from '@mui/icons-material/Inventory';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LabelIcon from '@mui/icons-material/Label';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import LensIcon from '@mui/icons-material/Lens';
import LibraryBooksMui from '@mui/icons-material/LibraryBooks';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LockClockIcon from '@mui/icons-material/LockClock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';
import Looks6Icon from '@mui/icons-material/Looks6';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MenuIcon from '@mui/icons-material/Menu';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MessageIcon from '@mui/icons-material/Message';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import MoreVertMui from '@mui/icons-material/MoreVert';
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NumbersIcon from '@mui/icons-material/Numbers';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import PaidIcon from '@mui/icons-material/Paid';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import PauseCircleOutlinedIcon from '@mui/icons-material/PauseCircleOutlined';
import PaymentsIcon from '@mui/icons-material/Payments';
import PeopleIconMui from '@mui/icons-material/People';
import PercentIcon from '@mui/icons-material/Percent';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RateReviewIcon from '@mui/icons-material/RateReview';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RedeemIcon from '@mui/icons-material/Redeem';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import Replay10Icon from '@mui/icons-material/Replay10';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import RuleIcon from '@mui/icons-material/Rule';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SellIcon from '@mui/icons-material/Sell';
import ShopIcon from '@mui/icons-material/Shop';
import SourceIcon from '@mui/icons-material/Source';
import SpatialAudioIcon from '@mui/icons-material/SpatialAudio';
import SpatialAudioOffIcon from '@mui/icons-material/SpatialAudioOff';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import SportsScoreOutlinedIcon from '@mui/icons-material/SportsScoreOutlined';
import StarIcon from '@mui/icons-material/Star';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import StoreIcon from '@mui/icons-material/Store';
import StyleIcon from '@mui/icons-material/Style';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import TabIcon from '@mui/icons-material/Tab';
import TableRowsIcon from '@mui/icons-material/TableRows';
import TagIcon from '@mui/icons-material/Tag';
import TaskIcon from '@mui/icons-material/Task';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import TitleIcon from '@mui/icons-material/Title';
import TodayIcon from '@mui/icons-material/Today';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import TranslateIcon from '@mui/icons-material/Translate';
import UploadIcon from '@mui/icons-material/Upload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VerifiedIcon from '@mui/icons-material/Verified';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import WatchIcon from '@mui/icons-material/Watch';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';

export const LockIcon = LockIconMui;
export const AccessCodeIcon = RedeemIcon;

export const UnlockIcon = LockOpenIcon;
export const GoToIcon = OpenInNewIcon;
export const TableIcon = TableRowsIcon;
export const HistoryIcon = WorkHistoryIcon;
export const LowestIcon = BrightnessLowIcon;
export const GraphIcon = BarChartIcon;
export const HighestIcon = BrightnessHighIcon;
export const DiscussionIcon = ForumIcon;
export const Minus10Icon = Replay10Icon;
export const CustomerSupportIcon = ContactSupportIcon;
export const AccessCodePurchaseIcon = ShopIcon;
export const Plus10Icon = Forward10Icon;
export const OpenFlagIcon = EmojiFlagsIcon;
export const MonthEndIcon = AssessmentIcon;
export const CloseFlagIcon = FlagIcon;
export const EnrollmentRoleIcon = ManageAccountsIcon;
export const PaymentIcon = PaymentsIcon;
export const ReportIcon = DescriptionIcon;
export const ProductIcon = InventoryIcon;
//export const EditionIcon = StyleIcon;
export const EditionIcon = AutoAwesomeMotionIcon;
export const IdentifierIcon = LabelIcon;
export const TextSizeIcon = FormatSizeIcon;
export const UpdateStatusIcon = ApprovalIcon;
export const BookTitleIcon = TitleIcon;
export const BookDescriptionIcon = DescriptionIcon;
export const BookDrmSettingsIcon = WifiOffIcon;
export const EditSettingsIcon = ChevronRightIcon;
export const EditImageIcon = EditIcon;
export const CancelItemIcon = CancelIcon;
export const BookDashboardIcon = DashboardIcon;
export const NumberOfPagesIcon = AutoStoriesIcon;
export const ShuffleIcon = ShuffleMui;
export const UnlinkIcon = LinkOffIcon;
export const ThumbsMaybeIcon = ThumbsUpDownIcon;
export const ThumbsNoIcon = ThumbDownIcon;
export const ThumbsYesIcon = ThumbUpIcon;
export const LanguageIcon = TranslateIcon;
export const ActiveIcon = ToggleOnIcon;
export const InactiveIcon = ToggleOffIcon;
export const AuthorsIcon = AttributionIcon;
export const NewItemIcon = AddCircleIcon;
export const DeleteItemIcon = DeleteIcon;
export const RefundIcon = CancelPresentationIcon;
export const CalendarWeekIcon = CalendarViewWeekIcon;
export const CalendarMonthIcon = CalendarViewMonthIcon;
export const ExtendDueDateIcon = CalendarMonthIconMui;
export const EditItemIcon = EditIcon;
export const EditionNameIcon = StyleIcon;
export const PrintIcon = PrintMui;
export const BuildIcon = BuildCircleIcon;
export const CloneIcon = ContentCopyIcon;
export const ManageIcon = VerifiedIcon;
export const BasicInformationIcon = InfoMui;
export const ImageIcon = CameraAltIcon;
export const DownloadIcon = DownloadForOfflineIcon;
export const ZoomOut2Icon = ZoomOutMui;
export const AddressIcon = BusinessIcon;
export const ZoomOutIcon = ZoomOutMapIcon;
export const ZoomInIcon = ZoomInMapIcon;
export const ZoomIn2Icon = ZoomInMui;
export const QuizTimeLimitIcon = AccessTimeIcon;
export const DropDateIcon = EventAvailableIcon;
export const TermNameIcon = CalendarTodayIcon;
export const TermIcon = CalendarTodayIcon;
export const DeactivateIcon = DangerousIcon;
export const PlayIcon = PlayCircleOutlinedIcon;
export const PauseIcon = PauseCircleOutlinedIcon;
export const SwitchVerticalIcon = SwapVertIcon;
export const StopIcon = StopCircleIcon;
export const MessagesIcon = MessageIcon;
export const EditMessagesIcon = RateReviewIcon;
export const ActivateIcon = PlayCircleFilledIcon;
export const StartAtIcon = TodayIcon;
export const EndAtIcon = EventIcon;
export const PeopleIcon = PeopleIconMui;
export const AccessTypeIcon = KeyMui;
export const QuestionPlacementIcon = NotListedLocationIcon;
export const CourseSectionsIcon = FormatListBulletedIcon;
export const LmsIdIcon = LabelIcon;
export const InvoiceAmountIcon = MonetizationOnIcon;
export const EnrollmentsIcon = HailIcon;
export const AdoptionsIcon = BackpackIcon;
export const StudyGuideIcon = AssignmentMui;
export const IdIcon = LabelIcon;
export const AttemptsIcon = NumbersIcon;
export const ModuleIcon = ViewModuleIcon;
export const ContentHubIcon = LibraryBooksMui;
export const PassedDueIcon = EventBusyIcon;
export const NotYetAvailableIcon = LockClockIcon;
export const SchoolIcon = SchoolIconMui;
export const PublisherIcon = BusinessIcon;
export const InternalIcon = StoreIcon;
export const ConnectionIcon = CableIcon;
export const JobIcon = WorkHistoryIcon;
export const OnixIcon = WorkHistoryIcon;
export const SuccessIcon = CheckCircleIcon;
export const FailIcon = DoNotDisturbIcon;
export const RefreshIcon = RefreshMui;
export const PriceIcon = SellIcon;
export const CostIcon = PriceChangeIcon;
export const CourseSectionCodeIcon = SubtitlesIcon;
export const DurationIcon = TimelapseIcon;
export const SignInIcon = LoginIcon;
export const SignOutIcon = LogoutIcon;
export const SignUpIcon = AddCircleOutlinedIcon;
export const RoleIcon = BadgeIcon;
export const EmailIcon = EmailMui;
export const DomainIcon = AlternateEmailIcon;
export const NameIcon = DnsIcon;
export const VolumeMuteIcon = VolumeOffMui;
export const VolumeOffIcon = VolumeDownIcon;
export const VolumeOnIcon = VolumeUpIcon;
export const CredentialsIcon = AppRegistrationIcon;
export const JobStatusIcon = CloudSyncIcon;
export const JobDeleteIcon = RemoveCircleOutlinedIcon;
export const JobErrorIcon = ErrorOutlinedIcon;
export const JobUpdateIcon = PanoramaFishEyeIcon;
export const JobInsertIcon = AddCircleOutlinedIcon;
export const JobScheduleIcon = ScheduleIcon;
export const VerticalKebabIcon = MoreVertMui;
export const OptedInIcon = StarIcon;
export const OptedOutIcon = StarOutlinedIcon;
export const CloseIcon = CloseMui;
export const ExpandIcon = KeyboardArrowDownIcon;
export const ChangeIcon = ChangeCircleIcon;
export const AdoptIcon = RuleIcon;
export const ExpandMoreIcon = ExpandMoreMui;
export const IsbnIcon = LabelImportantIcon;
export const ColorChooserIcon = ColorLensIcon;
export const AccountingIcon = AccountBalanceIcon;
export const NumberIcon = TagIcon;
export const TableOfContentsIcon = FormatListBulletedIcon;
export const ChargeIcon = CreditCardIcon;
export const TransactionIcon = ReceiptLongIcon;
export const SwapHorizontalIcon = SwapHorizIcon;
export const KeyIcon = KeyMui;
export const LessonIcon = TaskIcon;
export const AssignmentIcon = AssignmentMui;
export const ScopeIcon = FilterAltIcon;
export const StartIcon = StartMui;
export const EndIcon = SportsScoreOutlinedIcon;
export const PointsIcon = GradeOutlinedIcon;
export const PercentOfGradeIcon = PercentIcon;
export const ItalicIcon = FormatItalicIcon;
export const BoldIcon = FormatBoldIcon;
export const AIIcon = AutoAwesomeIcon;
export const UnderlineIcon = FormatUnderlinedIcon;
export const StrikethroughIcon = FormatStrikethroughIcon;
export const AlignLeftIcon = FormatAlignLeftIcon;
export const AlignCenterIcon = FormatAlignCenterIcon;
export const AlignRightIcon = FormatAlignRightIcon;
export const AlignJustifyIcon = FormatAlignJustifyIcon;
export const RedoIcon = RedoMui;
export const UndoIcon = UndoMui;
export const ContentIcon = SourceIcon;
export const HighlightIcon = HighlightMui;
export const SuperscriptIcon = SuperscriptMui;
export const SubscriptIcon = SubscriptMui;
export const CodeIcon = CodeMui;
export const TextColorIcon = FormatColorTextIcon;
export const BackgroundColorIcon = FormatColorFillIcon;
export const LinkIcon = LinkMui;
export const HighlightSelectorIcon = LensIcon;
export const OLIcon = FormatListNumberedIcon;
export const ULIcon = FormatListBulletedIcon;
export const ParagraphIcon = FormatIndentIncreaseIcon;
export const QuoteIcon = FormatQuoteIcon;
export const LmsCourseIcon = RocketLaunchIcon;
export const H1Icon = LooksOneIcon;
export const H2Icon = LooksTwoIcon;
export const H3Icon = Looks3Icon;
export const H4Icon = Looks4Icon;
export const H5Icon = Looks5Icon;
export const H6Icon = Looks6Icon;
export const InfoIcon = InfoOutlined;
export const AssignGradeIcon = GradingIcon;
export const ErrorIcon = ErrorMui;
export const StartDateIcon = TodayIcon;
export const EndDateIcon = EventIcon;
export const InvoiceIcon = ReceiptIcon;
export const BillingIcon = ReceiptIcon;
export const BookIcon = BookMui;
export const DistributorIcon = LocalShippingIcon;
export const AmountIcon = PaidIcon;
export const TimezoneIcon = WatchIcon;
export const AssignmentGroupIcon = GroupWorkIcon;
export const SyncIcon = SyncMui;
export const StudentIcon = SchoolIcon;
export const CalendarIcon = CalendarMonthIconMui;
export const SyllabusIcon = UploadFileIcon;
export const MaterialRequestIcon = AutoStoriesIcon;
export const AnalyticsIcon = LeaderboardIcon;
export const QuizIcon = QuizMui;
export const SlidesIcon = PresentToAllIcon;
export const ReadingComprehensionIcon = AutoStoriesIcon;
export const TestIcon = FactCheck;

export const DemosIcon = Tv;
export const TutorIcon = AssistantIcon;
export const StudyToolIcon = ConstructionIcon;
export const LeftArrowIcon = KeyboardArrowLeftIcon;
export const RightArrowIcon = KeyboardArrowRightIcon;
export const MaterialIcon = AttachFileIcon;
export const ItemTabsIcon = TabIcon;
export const StudyGuideFlashcardIcon = SwapHorizontalCircleIcon;
export const BookmarkUnselectedIcon = BookmarkBorderIcon;
export const BookmarkSelectedIcon = BookmarkIcon;
export const NoteIcon = AddCommentIcon;
export const MoveToIcon = OpenWithIcon;
export const QuestionIcon = HelpIcon;
export const DeckIcon = ViewModuleIcon;
export const Notes2Icon = SpeakerNotesIcon;
export const TTSIcon = SpatialAudioIcon;
export const TTSOffIcon = SpatialAudioOffIcon;
export const SaveIcon = NoteAddIcon;
export const SelectedIcon = RadioButtonCheckedIcon;
export const UnselectedIcon = RadioButtonUncheckedIcon;
export const IncorrectIcon = HighlightOffIcon;
export const ExplanationIcon = LightbulbIcon;
export const ChapterIcon = MenuBookIcon;
export const PageIcon = ArticleIcon;
export const SearchIcon = SearchMui;
export const HamburgerIcon = MenuIcon;
export const HamburgerOpenIcon = MenuOpenIcon;
export const FlashcardIcon = FlipIcon;
export const PedanticNoteIcon = EmojiObjectsIcon;
export const UploadItemsIcon = UploadIcon;
export const NewDeckIcon = DashboardCustomizeIcon;
export const CitationIcon = FormatQuoteIcon;
export const ReminderIcon = NotificationsIcon;
export const LocationCityIcon = LocationCityMui;
export const GroupsIcon = GroupsMui;
export const Diversity3Icon = Diversity3Mui;
export const ColumnsIcon = ViewColumnIcon;
export const FiltersIcon = FilterListIcon;
export const DensityIcon = TableRowsIcon;
export const PendingIcon = PendingMui;
export const CheckIcon = CheckMui;
export const ArrowForwardIcon = ArrowForwardMui;
export const ExportIcon = SaveAltIcon;
export const MoreVertIcon = MoreVertMui;

export enum IconSize {
  SMALL = '16',
  MEDIUM = '20',
  LARGE = '24',
}

export { default as TutorBadgeIcon } from './Icons/TutorBadgeIcon';
